/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  Suspense,
  useMemo,
} from "react";
import { lazyWithRetry } from "Utils/lazyWithRetry";
import { LoginContext } from "helpers/LoginContext";
import Header from "components/common/Header/Header";
import SideBar from "components/common/SideBar/SideBarNew";
import Loader from "components/common/Loader/Loader";
import {
  fetchOptionsForWorkerAndParticpant,
  formatDateIntoDMY,
} from "Utils/utils";
import refreshIcon from "assets/svg/refresh.svg";
import SelectOption from "components/common/Select/Select";
// import imgThree from "assets/images/Rectangle 1 (3).png";
// import imgOne from "assets/images/Rectangle 1 (1).png";
// import imgTwo from "assets/images/Rectangle 1 (2).png";
import { MdPublish } from "react-icons/md";
import { showToast } from "store/actions/general.actions";
import { useDispatch, useSelector } from "react-redux";
import PubishShiftModal from "./PublishShiftModal/PublishShiftModal";
import CustomButton from "components/common/Button/CustomButton";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import {
  LOADER_STATUS,
  ROSTERING_CALENDAR_DATA_LIMIT,
  TOAST_TYPE,
  emptyPaginationObj,
  getCalendarViewOptions,
  getParticipantLabel,
} from "Constants/constant";
import {
  ROSTERING_BREADCRUMB,
  ROSTERING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import Breadcrumb from "components/common/Breadcrumb";
import { BiExit, BiPlus, BiGroup } from "react-icons/bi";
import { FaExclamationCircle } from "react-icons/fa";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
import { useLocation, useNavigate } from "react-router";
import CopyShift from "components/Modals/CopyShift";
import { MdContentCopy } from "react-icons/md";
import MessageModal from "components/Modals/RecurringModal/MessageModal";
import { TiExportOutline } from "react-icons/ti";
import { HiOutlineClipboardList, HiOutlineTrash } from "react-icons/hi";
import { Tooltip } from "react-tooltip";
import { classNames } from "Utils/utils";
import ExportRosterModal from "./ExportRoster/ExportRosterModal";
import DeleteShiftsModal from "./DeleteShiftsModal/DeleteShiftsModal";
import { apiGetRequest, apiPostRequest } from "helpers/Requests";
import WorkerShiftModal from "../WorkerShift";
import {
  getSearchtextOfScheduleShifts,
  getShiftRequestsState,
  getCreateOrUpdateWorkerShiftError,
} from "store/selector/rostering.selector";
import _, { isArray, isEmpty } from "lodash";
import {
  fetchShiftRequests,
  updateCalendarSearchLocally,
  updateShiftRequestStatus,
  setPendingShiftRequestApproval,
  clearPendingShiftRequestApproval,
  workerShiftCreatedOrUpdated,
} from "store/actions/rostering.actions";
import NewDateRangeSelect from "components/common/CustomCalendar";
import {
  ScheduleCalendarSkeleton,
  SchedulePageSkeleton,
} from "./ScheduleSkeleton";
import "./ScheduleToolbar.css";
import "./ScheduleShell.css";
import {
  URL_ROSTERING_SHIFT_STATS,
  URL_ROSTERING_GET_OPEN_SHIFTS,
  URL_ROSTERING_GET_SELECTED_SERVICE_SUPPORT,
  URL_ROSTERING_UPDATE_SERVICE_SUPPORT,
} from "store/services/URL";
import rosteringApi from "store/services/rostering.services";
import OpenShiftModal from "./OpenShiftApproval/OpenShiftModal";
import ShiftRequestsModal from "./ShiftRequestsModal/ShiftRequestsModal";
import { serviceTypesRequest } from "helpers/apiCalls";
import pusher from "components/common/NotificationDropDown/Pusher";
import { NOTIFICATION_IDS } from "store/constants";
import { getUser } from "store/selector/auth.selector";

const Calendar = lazyWithRetry(
  () => import("../Calendar/Calendar"),
  "Rostering/Calendar"
);

const SCHEDULE_TOOLBAR_ACTION_BTN =
  "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg background-gradient border-gradient text-white shadow-sm hover:opacity-90 hover:scale-[1.03] transition focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1";
const SCHEDULE_TOOLBAR_REFRESH_BTN =
  "flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white cursor-pointer hover:bg-slate-50 hover:border-slate-300 transition focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed";
const SCHEDULE_TOOLBAR_ICON = "h-3.5 w-3.5";

const Schedule = (props) => {
  const {
    workerTimeSheetExportListRequest,
    workerTimeSheetExportList,
    workerAndParticipantOptions,
    getWorkerAndParticipantList,
    // sortCalendarShiftsItem,
    workerAndPartsListLoader,
    // isSortCalendarShiftsItem,
    calendarDateChangeLocally,
    workerAndParticipantShiftCopyRequest,
    copyWorkerShiftLoader,
    copyWorkerShiftError,
    isRecurringModalShow,
    recurringMessageModal,
    recurringMessages,
    spRosteringSettingsRequest,
    spRosteringSettingLoader,
    spRosteringSetting,
    getPublicHolidaysInYear,
  } = props;

  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);

  const calendarViewOptions = useMemo(
    () => getCalendarViewOptions(spRosteringSetting?.care_sector),
    [spRosteringSetting?.care_sector]
  );

  const myRef = useRef(null);
  const dispatch = useDispatch();
  const [workerOptions, setWorkerOptions] = useState([]);
  const [participantOptions, setParticipantOptions] = useState([]);
  // Dropdown catalogs stay full when calendar rows are filtered by selection.
  const [dropdownWorkerOptions, setDropdownWorkerOptions] = useState([]);
  const [dropdownParticipantOptions, setDropdownParticipantOptions] =
    useState([]);
  const [isDropdownCatalogLoading, setIsDropdownCatalogLoading] =
    useState(false);
  const dropdownCatalogLockedRef = useRef(false);
  // Full dropdown catalog (up to 1000) — independent of calendar scroll pages.
  const dropdownCatalogLoadedRef = useRef(false);
  const dropdownCatalogRequestIdRef = useRef(0);
  const [calendarView, setCalendarView] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isShowPublish, setIsShowPublish] = useState(false);
  const [isOpenShiftApprovalModal, setIsOpenShiftApprovalModal] =
    useState(false);
  const [isShiftRequestsModalOpen, setIsShiftRequestsModalOpen] =
    useState(false);
  const [selectedShiftRequest, setSelectedShiftRequest] = useState(null);
  const [shiftRequestLinkedShift, setShiftRequestLinkedShift] = useState(null);
  const [expandedFooter, setExpandedFooter] = useState(false);
  const [isFullScreenMode, setIsFullScreenMode] = useState(false);
  const [initialCopyLoader, setInitialLoader] = useState(LOADER_STATUS.NA);
  const [reachedLast, setReachedLast] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [isPaginationLoading, setIsPaginationLoading] = useState(
    LOADER_STATUS.NA
  );
  // Keep one continuous page skeleton on first land (settings + first calendar fetch).
  const [hasCompletedInitialCalendarLoad, setHasCompletedInitialCalendarLoad] =
    useState(false);
  const initialCalendarFetchStartedRef = useRef(false);
  const sawInitialCalendarLoaderRef = useRef(false);
  const prevScheduleViewRef = useRef(null);
  const prevScheduleDatesRef = useRef({ start: null, end: null });
  const [copiedText, setCopiedText] = useState(null);
  const [isOpenCopyShift, setCopyShifts] = useState(false);
  const [fortnightlyCopyShiftsMessage, setForthnightlyCopyShiftsMessage] =
    useState(null);
  const [isMessageForCopyShift, setIsMessage] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [deepLinkedShift, setDeepLinkedShift] = useState(null);
  const pendingOpenShiftRef = useRef(null);
  const [isShowCsvModal, setShowCSVModal] = useState(false);
  const [serviceCategoriesTypes, setServiceCategoriesTypes] = useState([]);
  const [isServiceCategoriesFetchCall, setIsServiceCategoriesFetchCall] =
    useState(false);

  const [isOpenShiftModal, setIsOpenShiftModal] = useState(false);
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false);

  const [isSortCalendarShiftsItem, setIsSortCalendarShiftsItem] =
    useState("asc");

  const searchText = useSelector(getSearchtextOfScheduleShifts);
  const currentLoggedInUser = useSelector(getUser);
  const spIdForPusher =
    currentLoggedInUser?.sp_id || currentLoggedInUser?.service_provider?.id;
  const [selectedDateTypes, setSelectedDateTypes] = useState(null);

  const [selectedOps, setSelectedops] = useState(null);
  const [openShiftRequestCount, setOpenShiftRequestCount] = useState(0);
  const { list: shiftRequests } = useSelector(getShiftRequestsState);
  const createOrUpdateWorkerShiftError = useSelector(
    getCreateOrUpdateWorkerShiftError
  );

  const shiftRequestLeaveError =
    isOpenShiftModal &&
    selectedShiftRequest &&
    typeof createOrUpdateWorkerShiftError === "string" &&
    createOrUpdateWorkerShiftError.includes(
      "on leave during the selected time"
    )
      ? createOrUpdateWorkerShiftError
      : null;

  const debounceTimeout = useRef();

  useEffect(() => {
    dispatch(fetchShiftRequests());
  }, [dispatch]);

  const applyShiftRequestDetailForView = (detail) => {
    const status = String(detail?.status || "").toLowerCase();
    if (status === "in_review" && detail?.shift_uuid) {
      setShiftRequestLinkedShift({ uuid: detail.shift_uuid });
    } else {
      setShiftRequestLinkedShift(null);
    }
    setSelectedShiftRequest(detail);
  };

  const handleViewShiftRequest = async (request) => {
    const requestUuid = request?.uuid;
    dispatch(setPendingShiftRequestApproval(requestUuid));

    const participantView = calendarViewOptions.find(
      (opt) => opt.value === "participant-view"
    );
    if (participantView && calendarView?.value !== "participant-view") {
      setCalendarView(participantView);
    }

    applyShiftRequestDetailForView(request);
    setIsOpenShiftModal(true);
    setIsShiftRequestsModalOpen(false);

    if (!requestUuid) {
      return;
    }

    try {
      const res = await rosteringApi.getShiftRequestDetail(requestUuid);
      const payload = res?.data?.data ?? res?.data ?? res;
      if (payload && typeof payload === "object") {
        applyShiftRequestDetailForView(payload);
      }
    } catch (e) {
      // Keep list row data already shown in the shift modal.
    }
  };

  useEffect(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    if (selectedOps === null) {
      return;
    }
    debounceTimeout.current = setTimeout(() => {
      const payload = { isRefreshCall: true };
      refreshCalendar(payload);
    }, 2000); // 2 seconds after last change
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [selectedOps]);

  useEffect(() => {
    scrollToRef(myRef);
  }, [myRef]);

  const scrollToRef = (ref) => {
    if (ref?.current) {
      ref.current.scrollTop = 0;
    }
  };

  const scrollablePagination = (reached, stopScrollPagination = false) => {
    if (stopScrollPagination) return;
    if (
      (reached || reachedLast) &&
      paginationObj.totalPages > paginationObj.page &&
      !workerAndPartsListLoader
    ) {
      const obj = paginationObj;
      obj.page = paginationObj.page + 1;
      setPaginationObj({ ...obj });
      setIsPaginationLoading(LOADER_STATUS.PENDING);
      refreshCalendar({ page: obj.page });
    }
  };

  // Single refresh path for view/date changes — avoids double fetch (and double
  // skeleton) when both become ready on first land. View vs date behavior is preserved.
  useEffect(() => {
    if (!startDate || !endDate || !calendarView?.value) return;

    const viewChanged = prevScheduleViewRef.current !== calendarView.value;
    const datesChanged =
      prevScheduleDatesRef.current.start !== startDate ||
      prevScheduleDatesRef.current.end !== endDate;

    if (!viewChanged && !datesChanged) return;

    prevScheduleViewRef.current = calendarView.value;
    prevScheduleDatesRef.current = { start: startDate, end: endDate };

    setIsPaginationLoading(LOADER_STATUS.NA);
    setReachedLast(false);

    if (!hasCompletedInitialCalendarLoad) {
      initialCalendarFetchStartedRef.current = true;
    }

    if (viewChanged) {
      // Same as previous [calendarView] effect
      dropdownCatalogLockedRef.current = false;
      setSelectedops(null);
      refreshCalendar({ isRefreshCall: true, notAddOps: true });
      return;
    }

    // Same as previous [startDate, endDate] effect (dates only)
    const payload = { isRefreshCall: true };
    if (!isEmpty(searchText)) {
      Object.assign(payload, {
        search: searchText,
      });
    }
    refreshCalendar(payload);
  }, [startDate, endDate, calendarView?.value]);

  useEffect(() => {
    if (
      !initialCalendarFetchStartedRef.current ||
      hasCompletedInitialCalendarLoad
    ) {
      return;
    }
    // Wait until the first fetch has actually entered loading, then finishes.
    // Avoids clearing the skeleton early on a stale loader=false from Redux.
    if (workerAndPartsListLoader) {
      sawInitialCalendarLoaderRef.current = true;
      return;
    }
    if (sawInitialCalendarLoaderRef.current) {
      setHasCompletedInitialCalendarLoad(true);
    }
  }, [workerAndPartsListLoader, hasCompletedInitialCalendarLoad]);

  // Safety: never trap the page on skeleton if the first fetch never starts/finishes.
  useEffect(() => {
    if (spRosteringSettingLoader || hasCompletedInitialCalendarLoad) return undefined;
    const timer = setTimeout(() => {
      setHasCompletedInitialCalendarLoad(true);
    }, 4000);
    return () => clearTimeout(timer);
  }, [spRosteringSettingLoader, hasCompletedInitialCalendarLoad]);

  // Load full worker/participant dropdown catalog once per view (up to 1000).
  // Kept separate from calendar row pagination so scroll never limits the select.
  // Client-side filtering in the select is enough — no server-side search.
  useEffect(() => {
    if (!calendarView?.value) return undefined;

    const requestId = ++dropdownCatalogRequestIdRef.current;
    const type =
      calendarView.value === "worker-view" ? "worker" : "participant";
    let cancelled = false;

    dropdownCatalogLoadedRef.current = false;
    setIsDropdownCatalogLoading(true);

    const loadDropdownCatalog = async () => {
      try {
        const options = await fetchOptionsForWorkerAndParticpant(type);
        if (
          cancelled ||
          requestId !== dropdownCatalogRequestIdRef.current
        ) {
          return;
        }

        const sorted = [...(options || [])].sort((a, b) =>
          String(a?.label || "")
            .localeCompare(String(b?.label || ""), undefined, {
              sensitivity: "base",
              numeric: true,
            })
        );

        if (type === "worker") {
          setDropdownWorkerOptions(sorted);
        } else {
          setDropdownParticipantOptions(sorted);
        }
        dropdownCatalogLoadedRef.current = true;
      } catch {
        // Keep any temporary seed from calendar pages; do not break the grid.
      } finally {
        if (
          !cancelled &&
          requestId === dropdownCatalogRequestIdRef.current
        ) {
          setIsDropdownCatalogLoading(false);
        }
      }
    };

    loadDropdownCatalog();

    return () => {
      cancelled = true;
    };
  }, [calendarView?.value]);

  // Handle Escape key to exit full-screen mode
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isFullScreenMode) {
        setIsFullScreenMode(false);
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isFullScreenMode]);

  // Disable body scroll when in full-screen mode
  useEffect(() => {
    if (isFullScreenMode) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isFullScreenMode]);

  useEffect(() => {
    if (workerAndParticipantOptions) {
      const { pagination, workers, participants } = workerAndParticipantOptions;
      setWorkerOptions(workers ? [...workers] : []);
      setParticipantOptions(participants ? [...participants] : []);
      setPaginationObj({ ...pagination });

      // Seed dropdown only until the full catalog arrives. Never shrink/replace
      // the 1000-item catalog with paginated calendar pages or selection filters.
      if (
        !dropdownCatalogLoadedRef.current &&
        !dropdownCatalogLockedRef.current
      ) {
        setDropdownWorkerOptions(workers ? [...workers] : []);
        setDropdownParticipantOptions(participants ? [...participants] : []);
      }
    }
  }, [workerAndParticipantOptions]);

  const handleDateChange = (dates) => {
    setSelectedDateTypes(dates);
    if (dates && dates?.startDate) {
      calendarDateChangeLocally({
        date: dates.startDate,
        view: dates?.view || "current",
      });
      setStartDate(dates.startDate);
    }
    if (dates && dates?.endDate) {
      setEndDate(dates.endDate);
    }
  };

  const refreshCalendar = (obj = {}) => {
    if (calendarView && startDate && endDate) {
      const payload = {
        data: {
          page: obj?.page || 1,
          per_page: obj?.per_page || ROSTERING_CALENDAR_DATA_LIMIT,
          type: calendarView.value === "worker-view" ? "worker" : "participant",
          from_date: formatDateIntoDMY(startDate),
          to_date: formatDateIntoDMY(endDate),
          sort: obj.hasOwnProperty("sort")
            ? obj.sort
            : isSortCalendarShiftsItem,
        },
        calendarView: calendarView.value,
      };

      if (obj && obj.hasOwnProperty("isRefreshCall")) {
        setIsPaginationLoading(LOADER_STATUS.NA);
        Object.assign(payload, {
          isRefreshCall: true,
        });
      }
      if (obj && obj.hasOwnProperty("search")) {
        setIsPaginationLoading(LOADER_STATUS.NA);
        Object.assign(payload.data, {
          search: obj.search,
        });
      }

      const usingSelectionFilter =
        selectedOps !== null &&
        selectedOps?.length > 0 &&
        !obj.hasOwnProperty("notAddOps");

      // Lock dropdown catalogs only while calendar fetch is scoped to selection.
      dropdownCatalogLockedRef.current = usingSelectionFilter;

      if (
        calendarView?.value === "worker-view" &&
        usingSelectionFilter
      ) {
        setIsPaginationLoading(LOADER_STATUS.PENDING);
        Object.assign(payload.data, {
          workers: selectedOps.map((x) => x.value),
          per_page: 100,
        });
      } else if (
        calendarView?.value === "participant-view" &&
        usingSelectionFilter
      ) {
        setIsPaginationLoading(LOADER_STATUS.PENDING);
        Object.assign(payload.data, {
          participants: selectedOps.map((x) => x.value),
          per_page: 100,
        });
      }

      if (obj?.status && payload.data) {
        payload.data.status = obj?.status;
      }

      getWorkerAndParticipantList(payload);
      if (selectedOps?.length > 0) {
        handleGetShiftStats(startDate, endDate, selectedOps);
      } else {
        handleGetShiftStats(startDate, endDate);
      }
    }
  };

  // Kept in a ref so the long-lived Pusher handler below always refreshes with
  // the filters that are on screen right now, not the ones from subscribe time.
  const refreshWithCurrentFiltersRef = useRef(null);
  useEffect(() => {
    refreshWithCurrentFiltersRef.current = () => {
      const payload = { isRefreshCall: true };
      if (!isEmpty(searchText)) {
        Object.assign(payload, { search: searchText });
      }
      refreshCalendar(payload);
    };
  });

  // Recurring series and multi-period roster copies are cloned on a queue, so
  // the shifts land well after the request returned. The backend broadcasts
  // once each is done.
  useEffect(() => {
    if (!pusher || !spIdForPusher) {
      return undefined;
    }

    const channelName = `rostering-sp-${spIdForPusher}`;
    const channel = pusher.subscribe(channelName);

    const handleNotify = (obj) => {
      const key = obj?.message?.key;
      const total = obj?.message?.total;

      if (key === NOTIFICATION_IDS.RECURRING_SHIFT_GENERATED) {
        dispatch(
          showToast({
            type: TOAST_TYPE.SUCCESS,
            title: total
              ? `${total} recurring shift${total > 1 ? "s" : ""} generated.`
              : "Recurring shifts generated.",
          })
        );
      } else if (key === NOTIFICATION_IDS.ROSTER_COPY_COMPLETED) {
        dispatch(
          showToast({
            type: TOAST_TYPE.SUCCESS,
            title: total
              ? `${total} shift${total > 1 ? "s" : ""} copied.`
              : "Roster copy finished.",
          })
        );
      } else {
        return;
      }

      refreshWithCurrentFiltersRef.current?.();
    };

    channel.bind("notify", handleNotify);

    return () => {
      channel.unbind("notify", handleNotify);
      pusher.unsubscribe(channelName);
    };
  }, [spIdForPusher]);

  const clearClipboard = () => {
    setCopiedText(null);
  };

  const handlePasteShift = ({ calendarDate, userId }) => {
    if (!copiedText?.uuid || userId == null) return;

    const currentTimeZone = momentTimeZone.tz.guess();
    const targetUserId = Number(userId);

    // Destination row owns the "view" side of the assignment:
    // worker-view → new worker_id; participant-view → new pt_id.
    // The other side is taken from the copied shift.
    const workerIdValue =
      calendarView.value === "worker-view"
        ? [targetUserId]
        : copiedText.worker_id !== null && copiedText.worker_id !== undefined
        ? Array.isArray(copiedText.worker_id)
          ? copiedText.worker_id.map(Number)
          : [Number(copiedText.worker_id)]
        : [null]; // open shifts (no worker assigned)

    const participantIdValue =
      calendarView.value === "participant-view"
        ? [targetUserId]
        : Array.isArray(copiedText.pt_id)
        ? copiedText.pt_id.map(Number)
        : copiedText.pt_id != null
        ? [Number(copiedText.pt_id)]
        : [];

    const payloadData = {
      timezone: currentTimeZone,
      uuid: copiedText.uuid,
      shift_date: moment(new Date(calendarDate)).toISOString(),
      pt_id: participantIdValue,
      worker_id: workerIdValue,
    };

    setInitialLoader(LOADER_STATUS.PENDING);
    workerAndParticipantShiftCopyRequest({
      payload: {
        ...payloadData,
      },
      calendarView: calendarView.value,
      userId: targetUserId,
    });
  };

  useEffect(() => {
    if (
      !copyWorkerShiftLoader.hasOwnProperty("data") &&
      initialCopyLoader === LOADER_STATUS.PENDING &&
      copyWorkerShiftError.length === 0
    ) {
      clearClipboard();
      setInitialLoader(LOADER_STATUS.COMPLATE);
    }
  }, [copyWorkerShiftLoader]);

  useEffect(() => {
    if (copiedText) {
      dispatch(showToast({ type: TOAST_TYPE.DEFAULT, title: "Shift copied!" }));
    }
  }, [copiedText]);

  useEffect(() => {
    spRosteringSettingsRequest();

    return () => {
      clearClipboard();
      dispatch(updateCalendarSearchLocally(null));
    };
  }, []);

  // Open shift editor when navigated here from Code Allocation (or similar).
  useEffect(() => {
    const openShift = location.state?.openShift;
    if (!openShift?.uuid) return;

    pendingOpenShiftRef.current = {
      uuid: openShift.uuid,
      is_multi_assignment: Boolean(openShift.is_multi_assignment),
      date: openShift.date || null,
    };

    // Clear state so refresh / back does not reopen the modal.
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.state, location.pathname, navigate]);

  useEffect(() => {
    const pending = pendingOpenShiftRef.current;
    if (!pending?.uuid || !calendarView?.value) return;

    pendingOpenShiftRef.current = null;
    setDeepLinkedShift(pending);
  }, [calendarView?.value]);

  useEffect(() => {
    if (spRosteringSetting?.id) {
      setCalendarView(
        calendarViewOptions?.find(
          (x) =>
            x.value === "worker-view" &&
            spRosteringSetting.roster_default_view === "worker"
        )
          ? calendarViewOptions[1]
          : calendarViewOptions[0]
      );
    }
  }, [spRosteringSetting, calendarViewOptions]);

  useEffect(() => {
    if (!workerAndPartsListLoader && isPaginationLoading !== LOADER_STATUS.NA) {
      setIsPaginationLoading(LOADER_STATUS.COMPLATE);
    }
  }, [workerAndPartsListLoader]);

  useEffect(() => {
    setCopiedText(null);
  }, [calendarView]);

  const getMaxHeight = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 900) {
      return 400;
    } else if (screenWidth < 1280) {
      return 500;
    } else {
      return 600; // default max height
    }
  };

  useEffect(() => fetchServiceCategoriesTypes(), []);
  useEffect(() => {

    if(startDate && endDate) {
      getPublicHolidaysInYear({from:formatDateIntoDMY(startDate), to:formatDateIntoDMY(endDate)});
    }
  }, [startDate, endDate]);

  const fetchServiceCategoriesTypes = () => {
    setIsServiceCategoriesFetchCall(true);
    apiGetRequest("/roster-invoices/service-type")
      .then((res) => {
        if (res.data) {
          const modifiedValues = res?.data?.data?.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setServiceCategoriesTypes(modifiedValues);
        }
        setIsServiceCategoriesFetchCall(false);
      })
      .catch((error) => console.log({ error }));
    setIsServiceCategoriesFetchCall(false);
  };

  const [shiftStats, setShiftStats] = useState(null);
  useEffect(() => {
    handleGetShiftStats(startDate, endDate);
  }, []);

  const handleGetShiftStats = (startDate, endDate, workerOrParticipantIds) => {
    if (!startDate || !endDate) return;

    const payload = {
      start_date: formatDateIntoDMY(startDate),
      end_date: formatDateIntoDMY(endDate),
      type: calendarView?.value === "worker-view" ? "worker" : "participant",
    };
    if (
      calendarView?.value === "worker-view" &&
      workerOrParticipantIds?.length > 0
    ) {
      payload.worker_id = workerOrParticipantIds?.map((x) => x.id);
    } else if (
      calendarView?.value === "participant-view" &&
      workerOrParticipantIds?.length > 0
    ) {
      payload.pt_id = workerOrParticipantIds?.map((x) => x.id);
    }
    apiPostRequest(URL_ROSTERING_SHIFT_STATS, payload)
      .then((res) => {
        setShiftStats(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (
      spRosteringSetting?.open_shift_claim_request &&
      !isOpenShiftApprovalModal
    ) {
      const view = calendarView?.value === "worker-view" ? "worker" : "participant";
      apiGetRequest(
        `${URL_ROSTERING_GET_OPEN_SHIFTS}?status=pending&page=1&per_page=1&view=${view}`
      )
        .then((res) => {
          const total = res?.data?.data?.pagination?.total || 0;
          setOpenShiftRequestCount(total);
        })
        .catch(() => {});
    }
  }, [spRosteringSetting?.open_shift_claim_request, calendarView]);

  const handleRejectShiftRequest = (request) => {
    dispatch(
      updateShiftRequestStatus({
        uuid: request.uuid,
        status: "rejected",
      })
    );
  };

  const shiftRequestStatusCounts = useMemo(() => {
    const counts = { pending: 0, approved: 0, rejected: 0, in_review: 0 };
    shiftRequests.forEach((request) => {
      const status = String(request?.status || "").toLowerCase();
      if (status in counts) {
        counts[status] += 1;
      }
    });
    return counts;
  }, [shiftRequests]);

  const shiftRequestsPendingCount = shiftRequestStatusCounts.pending;

  /*Service Type Code for filtering the schedule screen according to service type */
  const [serviceTypeOptions, setServiceTypeOptions] = useState([]);
  const [serviceTypeSelectedOptions, setServiceTypeSelectedOptions] = useState(
    []
  );
  const [serviceTypeLoader, setServiceTypeLoader] = useState(false);
  const serviceTypeDebounceTimeout = useRef();
  useEffect(() => {
    const fetchServiceTypes = async () => {
      setServiceTypeLoader(true);
      try {
        const res = await serviceTypesRequest();
        const serviceType = res?.data?.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setServiceTypeOptions(serviceType);

        try {
          const selectedRes = await apiGetRequest(
            `${URL_ROSTERING_GET_SELECTED_SERVICE_SUPPORT}`
          );
          const selectedServiceType = selectedRes?.data?.service_types?.map(
            (item) => ({
              label: item.name,
              value: item.id,
            })
          );
          setServiceTypeSelectedOptions(
            selectedServiceType?.length
              ? selectedServiceType
              : serviceType?.length
                ? [serviceType[0]]
                : []
          );
          setServiceTypeLoader(false);
        } catch (err) {
          setServiceTypeLoader(false);
          console.error("Error fetching selected service support:", err);
        }
      } catch (err) {
        setServiceTypeLoader(false);
        console.error("Error fetching service types:", err);
      }
    };

    if (calendarView?.value === "participant-view") {
      fetchServiceTypes();
    }
  }, [calendarView?.value]);

  const handleServiceTypeChange = async (selectedOptions) => {

    if (!selectedOptions || selectedOptions.length === 0) {
      dispatch(
        showToast({
          type: TOAST_TYPE.ERROR,
          title: "At least one Service Support must be selected",
          id: "service_type_error_toast",
        })
      );
      return;
    }


    setServiceTypeSelectedOptions(selectedOptions);


    if (serviceTypeDebounceTimeout.current) {
      clearTimeout(serviceTypeDebounceTimeout.current);
    }

    serviceTypeDebounceTimeout.current = setTimeout(() => {
        setServiceTypeLoader(true);
      apiPostRequest(`${URL_ROSTERING_UPDATE_SERVICE_SUPPORT}`, {
        service_type_id: selectedOptions.map((item) => item.value),
      })
        .then((res) => {
          dispatch(
            showToast({
              type: TOAST_TYPE.SUCCESS,
              title: "Service Support updated successfully",
            })
          );
          const payload = { isRefreshCall: true };
          refreshCalendar(payload);

          // Call open shifts API when service support changes
          if (spRosteringSetting?.open_shift_claim_request && !isOpenShiftApprovalModal) {
            const view = calendarView?.value === "worker-view" ? "worker" : "participant";
            apiGetRequest(
              `${URL_ROSTERING_GET_OPEN_SHIFTS}?status=pending&page=1&per_page=1&view=${view}`
            )
              .then((res) => {
                const total = res?.data?.data?.pagination?.total || 0;
                setOpenShiftRequestCount(total);
              })
              .catch(() => {});
          }
        })
        .catch((err) => {
          console.error("Error updating service support:", err);
          dispatch(
            showToast({
              type: TOAST_TYPE.ERROR,
              title: "Failed to update Service Support",
            })
          );
        }).finally(() => {
          setServiceTypeLoader(false);
        });
    }, 2000);
  };

  return (
    <div className='schedule-shell schedule-shell--page bg-slate-50' style={{ position: "sticky" }}>
      <SideBar />
      <div
        className={`duration-300 flex flex-col ${
          sideBarPadding ? "lg:pl-[4rem]" : "lg:pl-64"
        }`}
      >
        <Header
          btnComponent={
            <>
              <CustomButton
                label='Redirect To Timesheet'
                Icon={<BiExit />}
                clickHandler={() => navigate("/rostering/timesheet")}
              />
            </>
          }
          breadcrumb={
            <Breadcrumb
              pages={ROSTERING_BREADCRUMB(ROSTERING_BREADCRUMB_PAGES.SCHEDULE)}
            />
          }
        />
        {spRosteringSettingLoader ? (
          <SchedulePageSkeleton />
        ) : (
          <>
          {/* Keep one continuous skeleton until the first calendar fetch finishes.
              Main stays mounted (hidden) so the date picker can initialize dates. */}
          {!hasCompletedInitialCalendarLoad && <SchedulePageSkeleton />}
          <main
            className={`flex-1 relative${
              !hasCompletedInitialCalendarLoad ? " hidden" : ""
            }`}
            aria-hidden={!hasCompletedInitialCalendarLoad}
          >
            <section className='schedule-shell schedule-shell--page px-5 py-3 min-h-[calc(100vh-160px)]'>
              <div className='schedule-toolbar schedule-toolbar--elevated mb-3 rounded-xl border border-slate-200 bg-white px-3 py-3.5'>
                <div className='schedule-toolbar-row flex w-full min-w-0 flex-wrap items-end gap-1.5 lg:gap-2'>
                  <div className='schedule-toolbar-main flex flex-nowrap items-end gap-1.5 lg:gap-2'>
                  <div className='schedule-toolbar-filters flex flex-nowrap items-end gap-x-1.5 lg:gap-x-2'>
                  <div className='flex w-[140px] shrink-0 flex-col'>
                    <label className='mb-1 block text-xs font-medium leading-4 text-gray-600'>
                      View
                    </label>
                    <SelectOption
                      cssClass='schedule-toolbar-select normal-case'
                      isSearch={false}
                      useMenuPortal={true}
                      selectedOption={calendarView}
                      handleChange={setCalendarView}
                      data={calendarViewOptions}
                    />
                  </div>
                  {calendarView?.value === "participant-view" && (
                    <div className='schedule-service-support flex w-max shrink-0 flex-col'>
                      <label className='mb-1 block text-xs font-medium leading-4 text-gray-600'>
                        Service Support
                      </label>
                      <SelectOption
                        cssClass='z-50 roster-compact-multiselect normal-case'
                        isMulti
                        useMenuPortal={true}
                        isLoading={serviceTypeLoader || spRosteringSettingLoader}
                        isDisabled={serviceTypeLoader || spRosteringSettingLoader}
                        isClearable={false}
                        isSearch={false}
                        selectedOption={serviceTypeSelectedOptions}
                        handleChange={handleServiceTypeChange}
                        data={serviceTypeOptions}
                      />
                    </div>
                  )}
                  </div>

                  <div className='schedule-date-range shrink-0'>
                    <NewDateRangeSelect
                      enableDailyView
                      defaultType={spRosteringSetting?.calendar_type}
                      defaultFortnightView={
                        spRosteringSetting?.default_fortnight
                      }
                      dateHandler={handleDateChange}
                    />
                  </div>
                  </div>

                  <div className='schedule-toolbar-actions ml-auto flex w-full shrink-0 flex-nowrap items-center justify-end sm:w-auto'>
                  <button
                    type='button'
                    data-tooltip-id='add-shift-tooltip'
                    data-tooltip-content='Add Shift'
                    disabled={isUserGracePeriodOver}
                    onClick={() => {
                      if (isUserGracePeriodOver) {
                        return;
                      }
                      setSelectedShiftRequest(null);
                      setIsOpenShiftModal(true);
                    }}
                    className={classNames(
                      SCHEDULE_TOOLBAR_ACTION_BTN,
                      isUserGracePeriodOver ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                    )}
                  >
                    <BiPlus className={SCHEDULE_TOOLBAR_ICON} />
                  </button>
                  <button
                    type='button'
                    data-tooltip-id='delete-shifts-tooltip'
                    data-tooltip-content='Delete Shifts'
                    disabled={isUserGracePeriodOver}
                    onClick={() => {
                      if (isUserGracePeriodOver) {
                        return;
                      }
                      setIsShowDeleteModal(true);
                    }}
                    className={classNames(
                      SCHEDULE_TOOLBAR_ACTION_BTN,
                      isUserGracePeriodOver ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                    )}
                  >
                    <HiOutlineTrash className={SCHEDULE_TOOLBAR_ICON} />
                  </button>
                  <button
                    type='button'
                    data-tooltip-id='copy-shifts-tooltip'
                    data-tooltip-content='Copy Shifts'
                    onClick={() => setCopyShifts(true)}
                    className={SCHEDULE_TOOLBAR_ACTION_BTN + " cursor-pointer"}
                  >
                    <MdContentCopy className={SCHEDULE_TOOLBAR_ICON} />
                  </button>
                  <button
                    type='button'
                    data-tooltip-id='publish-shifts-tooltip'
                    data-tooltip-content='Publish Shifts'
                    onClick={() => setIsShowPublish(true)}
                    className={SCHEDULE_TOOLBAR_ACTION_BTN + " cursor-pointer"}
                  >
                    <MdPublish className={SCHEDULE_TOOLBAR_ICON} />
                  </button>
                  <button
                    type='button'
                    data-tooltip-id='export-roster-tooltip'
                    data-tooltip-content='Export Roster'
                    disabled={isUserGracePeriodOver}
                    onClick={() => {
                      if (isUserGracePeriodOver) {
                        return;
                      }
                      setShowCSVModal(true);
                    }}
                    className={classNames(
                      SCHEDULE_TOOLBAR_ACTION_BTN,
                      isUserGracePeriodOver ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                    )}
                  >
                    <TiExportOutline className={SCHEDULE_TOOLBAR_ICON} />
                  </button>
                  <button
                    type='button'
                    data-tooltip-id='shift-requests-tooltip'
                    data-tooltip-content='Shift Requests'
                    disabled={isUserGracePeriodOver}
                    onClick={() => {
                      if (isUserGracePeriodOver) {
                        return;
                      }
                      setIsShiftRequestsModalOpen(true);
                    }}
                    className={classNames(
                      "relative flex items-center justify-center h-7 w-7 shrink-0 rounded-md background-gradient border-gradient text-white shadow-sm hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1",
                      isUserGracePeriodOver
                        ? "cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    )}
                  >
                    <HiOutlineClipboardList className='h-3.5 w-3.5' />
                    {shiftRequestsPendingCount > 0 && (
                      <span className='absolute -top-0.5 -right-0.5 flex min-h-[12px] min-w-[12px] items-center justify-center rounded-full bg-red-600 px-0.5 text-[7px] font-medium text-white'>
                        {shiftRequestsPendingCount > 99
                          ? "99+"
                          : shiftRequestsPendingCount}
                      </span>
                    )}
                  </button>
                  {spRosteringSetting?.open_shift_claim_request && (
                    <button
                      type='button'
                      data-tooltip-id='open-shifts-tooltip'
                      data-tooltip-content={`Open Shifts${openShiftRequestCount > 0 ? ` (${openShiftRequestCount > 99 ? '99+' : openShiftRequestCount})` : ''}`}
                      disabled={isUserGracePeriodOver}
                      onClick={() => {
                        if (isUserGracePeriodOver) {
                          return;
                        }
                        setIsOpenShiftApprovalModal(true);
                      }}
                      className={classNames(
                        "relative " + SCHEDULE_TOOLBAR_ACTION_BTN,
                        isUserGracePeriodOver ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                      )}
                    >
                      <BiGroup className={SCHEDULE_TOOLBAR_ICON} />
                      {openShiftRequestCount > 0 && (
                        <span className='absolute -top-0.5 -right-0.5 flex min-h-[12px] min-w-[12px] items-center justify-center rounded-full bg-red-600 px-0.5 text-[7px] font-medium text-white'>
                          {openShiftRequestCount > 99 ? "99+" : openShiftRequestCount}
                        </span>
                      )}
                    </button>
                  )}
                  <button
                    type='button'
                    data-tooltip-id='fullscreen-tooltip'
                    data-tooltip-content='Full Screen'
                    onClick={() => setIsFullScreenMode(true)}
                    className={SCHEDULE_TOOLBAR_ACTION_BTN + " cursor-pointer"}
                  >
                    <MdFullscreen className={SCHEDULE_TOOLBAR_ICON} />
                  </button>
                  <button
                    type='button'
                    data-tooltip-id='refresh-tooltip'
                    data-tooltip-content='Refresh'
                    onClick={() => {
                      if (!workerAndPartsListLoader) {
                        refreshCalendar({ isRefreshCall: true });
                      }
                    }}
                    disabled={workerAndPartsListLoader}
                    className={SCHEDULE_TOOLBAR_REFRESH_BTN}
                  >
                    {workerAndPartsListLoader ? (
                      <Loader
                        isSmallView={true}
                        cssClass={"text-black mr-0 p-0 flex"}
                      />
                    ) : (
                      <img
                        className={SCHEDULE_TOOLBAR_ICON}
                        src={refreshIcon}
                        alt='refresh icon'
                      />
                    )}
                  </button>

                  <Tooltip id='add-shift-tooltip' place='top' />
                  <Tooltip id='delete-shifts-tooltip' place='top' />
                  <Tooltip id='copy-shifts-tooltip' place='top' />
                  <Tooltip id='publish-shifts-tooltip' place='top' />
                  <Tooltip id='export-roster-tooltip' place='top' />
                  <Tooltip id='shift-requests-tooltip' place='top' />
                  <Tooltip id='open-shifts-tooltip' place='top' />
                  <Tooltip id='fullscreen-tooltip' place='top' />
                  <Tooltip id='refresh-tooltip' place='top' />
                  </div>
                </div>
              </div>
              <div className='schedule-calendar-surface relative z-0 mt-2'>
                {(workerAndPartsListLoader &&
                  isPaginationLoading === LOADER_STATUS.NA) ||
                isServiceCategoriesFetchCall ? (
                  <ScheduleCalendarSkeleton />
                ) : (
                  calendarView?.value && (
                    <Suspense fallback={<ScheduleCalendarSkeleton />}>
                      <Calendar
                        reachedLast={reachedLast}
                        isPaginationLoading={isPaginationLoading}
                        paginationObj={paginationObj}
                        isUserGracePeriodOver={isUserGracePeriodOver}
                        workerAndPartsListLoader={workerAndPartsListLoader}
                        isSort={isSortCalendarShiftsItem}
                        calendarView={calendarView.value}
                        workers={workerOptions}
                        participants={participantOptions}
                        dropdownWorkers={dropdownWorkerOptions}
                        dropdownParticipants={dropdownParticipantOptions}
                        isUserSearchLoading={isDropdownCatalogLoading}
                        sortCalendarShiftsItem={(e) => {
                          setIsSortCalendarShiftsItem(e);
                          refreshCalendar({ sort: e, isRefreshCall: true });
                        }}
                        clearClipboard={clearClipboard}
                        setCopiedText={setCopiedText}
                        copiedText={copiedText}
                        handlePasteShift={handlePasteShift}
                        copyWorkerShiftLoader={copyWorkerShiftLoader}
                        refreshCalendar={refreshCalendar}
                        setReachedLast={setReachedLast}
                        scrollablePagination={scrollablePagination}
                        serviceCategoriesTypes={serviceCategoriesTypes}
                        selectedOps={selectedOps}
                        setSelectedops={setSelectedops}
                        handleGetShiftStats={handleGetShiftStats}
                        startDate={startDate}
                        endDate={endDate}
                        spRosteringSetting={spRosteringSetting}
                         serviceTypeSelectedOptions={serviceTypeSelectedOptions}
                      />
                    </Suspense>
                  )
                )}
              </div>
            </section>
            <section
              className='schedule-legend sticky bottom-0 z-50 schedule-custom-width py-3.5'
            >
              <div className='schedule-legend-inner px-4'>
                <div className='schedule-legend-chip'>
                  <span className='schedule-legend-dot schedule-legend-dot--unpublished' />
                  <p>
                    <strong>{shiftStats?.unpublished_shifts || 0}</strong> Unpublished
                  </p>
                </div>
                <div className='schedule-legend-chip'>
                  <span className='schedule-legend-dot schedule-legend-dot--published' />
                  <p>
                    <strong>{shiftStats?.published_shifts || 0}</strong> Published
                  </p>
                </div>
                <div className='schedule-legend-chip'>
                  <span className='schedule-legend-dot schedule-legend-dot--rejected' />
                  <p>
                    <strong>{shiftStats?.rejected_shifts || 0}</strong> Rejected
                  </p>
                </div>
                <div className='schedule-legend-chip'>
                  <span className='schedule-legend-dot schedule-legend-dot--open' />
                  <p>
                    <strong>{shiftStats?.open_shifts || 0}</strong> Open
                  </p>
                </div>
                <div className='schedule-legend-chip'>
                  <span className='schedule-legend-dot schedule-legend-dot--partial-open' />
                  <p>
                    <strong>{shiftStats?.v5_partial_open_slots || 0}</strong>{" "}
                    Partial Open
                  </p>
                </div>
              </div>
            </section>

            {/*Schedule footer section*/}
            {/* <section
            className={`border-t bg-white py-5 fixed bottom-0 max-h-[217px] schedule-custom-width  ${
              expandedFooter ? "" : "px-5"
            }`}
          >
            {expandedFooter && (
              <h3 className='text-gray-900 text-xl font-medium mb-0 pb-5 px-5'>
                NDIS External Courses
              </h3>
            )}
            <div
              className={`flex justify-between items-center gap-3 ${
                expandedFooter ? "border-t border-gray-400 p-5" : ""
              }`}
            >
              {expandedFooter ? (
                <div className='flex items-center justify-start gap-x-5'>
                  {expandedFooterContent.map((item, index) => (
                    <div key={index}>
                      <img
                        src={item.img}
                        alt=''
                        className='w-[88px] h-[88px] rounded-xl'
                      />
                      <div className=''>
                        <h5 className='text-gray-900 text-xl font-medium mb-0'>
                          {item.title}
                        </h5>
                        <span className='text-[#667085] text-sm font-normal'>
                          {item.price}
                        </span>
                        <span className='text-[#4B6CB7] text-sm font-medium pl-3 cursor-pointer'>
                          View Course
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className='flex items-center gap-x-7'>
                  <img src={bookIcon} alt='book icon' className='max-w-40' />
                  <h3 className='text-gray-900 text-xl font-medium mb-0'>
                    View Courses
                  </h3>
                  <p className='mb-0 text-gray-500 text-sm font-normal'>
                    Become a Master in Your Field with Our Comprehensive Course.
                  </p>
                </div>
              )}

              <div
                className='bg-gray-50 rounded-full w-12 h-12 inline-flex items-center justify-center cursor-pointer'
                onClick={() => setExpandedFooter(!expandedFooter)}
              >
                <img
                  src={expandedFooter ? arrowDownSvg : arrowUpSvg}
                  alt={expandedFooter ? "arrow down" : "arrow up"}
                />
              </div>
            </div>
          </section> */}
          </main>
          </>
        )}
      </div>
      {isShowCsvModal && (
        <ExportRosterModal
          calendarViewValue={calendarView.value}
          handleClose={() => setShowCSVModal(false)}
          isShow={isShowCsvModal}
          participantNameLabel={getParticipantLabel(spRosteringSetting?.care_sector, false) + " Name"}
          workerTimeSheetExportListRequest={workerTimeSheetExportListRequest}
          workerTimeSheetExportList={workerTimeSheetExportList}
        />
      )}
      {isOpenCopyShift && (
        <CopyShift
          isUserGracePeriodOver={isUserGracePeriodOver}
          title={"Copy Shifts"}
          setCopyShifts={setCopyShifts}
          isOpen={isOpenCopyShift}
          startDate={startDate}
          endDate={endDate}
          setForthnightlyCopyShiftsMessage={setForthnightlyCopyShiftsMessage}
          recurringMessageModal={recurringMessageModal}
          setIsMessage={setIsMessage}
          selectedDateTypes={selectedDateTypes}
          ShiftData={
            calendarView?.value === "worker-view"
              ? workerOptions
              : participantOptions
          }
          calendarView={calendarView?.value}
        />
      )}
      {isShowPublish && (
        <PubishShiftModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          calendarView={calendarView.value}
          handleClose={() => setIsShowPublish(false)}
          isShow={isShowPublish}
          selectedDateTypes={selectedDateTypes}
          handleGetShiftStats={handleGetShiftStats}
          startDate={startDate}
          endDate={endDate}
          selectedOps={selectedOps}
          participantNameLabel={getParticipantLabel(spRosteringSetting?.care_sector, false) + " Name"}
        />
      )}
      {isRecurringModalShow && (
        <MessageModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          setCopyShifts={recurringMessageModal}
          isOpen={isRecurringModalShow}
          reccuringResponseData={
            isMessageForCopyShift
              ? fortnightlyCopyShiftsMessage
              : recurringMessages
          }
          refreshCalendar={() => {
            const payload = { isRefreshCall: true };
            if (!isEmpty(searchText)) {
              Object.assign(payload, {
                search: searchText,
              });
            }
            refreshCalendar(payload);
          }}
          setIsMessage={setIsMessage}
        />
      )}
      {isOpenShiftModal && (
        <WorkerShiftModal
          isCallFromAddShift={true}
          selectedShift={shiftRequestLinkedShift}
          isShow={isOpenShiftModal}
          shiftRequestLeaveError={shiftRequestLeaveError}
          handleClose={() => {
            setIsOpenShiftModal(false);
            setSelectedShiftRequest(null);
            setShiftRequestLinkedShift(null);
            dispatch(clearPendingShiftRequestApproval());
            dispatch(workerShiftCreatedOrUpdated.error(""));
          }}
          selectedDate={
            selectedShiftRequest?.req_date
              ? moment(selectedShiftRequest.req_date).format("YYYY-MM-DD")
              : null
          }
          userItem={selectedShiftRequest?.participants?.[0] || null}
          prefillFromShiftRequest={selectedShiftRequest}
          calendarView={calendarView?.value}
          refreshCalendar={refreshCalendar}
          isUserGracePeriodOver={isUserGracePeriodOver}
          spRosteringSetting={spRosteringSetting}
          serviceTypeSelectedOptions={serviceTypeSelectedOptions}
          handleGetShiftStats={handleGetShiftStats}
          startDate={startDate}
          endDate={endDate}
          selectedOps={selectedOps}
        />
      )}
      {deepLinkedShift && (
        <WorkerShiftModal
          selectedShift={deepLinkedShift}
          isShow={Boolean(deepLinkedShift)}
          handleClose={() => {
            setDeepLinkedShift(null);
            if (typeof refreshCalendar === "function") {
              refreshCalendar({ isRefreshCall: true });
            }
          }}
          selectedDate={deepLinkedShift?.date || null}
          userItem={null}
          calendarView={calendarView?.value}
          refreshCalendar={refreshCalendar}
          isUserGracePeriodOver={isUserGracePeriodOver}
          spRosteringSetting={spRosteringSetting}
          handleGetShiftStats={handleGetShiftStats}
          startDate={startDate}
          endDate={endDate}
          selectedOps={selectedOps}
        />
      )}
      {isShiftRequestsModalOpen && (
        <ShiftRequestsModal
          isOpen={isShiftRequestsModalOpen}
          onClose={() => setIsShiftRequestsModalOpen(false)}
          isUserGracePeriodOver={isUserGracePeriodOver}
          serviceTypeOptions={serviceTypeOptions}
          onView={handleViewShiftRequest}
          onReject={handleRejectShiftRequest}
        />
      )}
      {isOpenShiftApprovalModal && (
        <OpenShiftModal
          handleClose={() => setIsOpenShiftApprovalModal(false)}
          isShow={isOpenShiftApprovalModal}
          calendarView={calendarView?.value}
          isUserGracePeriodOver={isUserGracePeriodOver}
          isOpenShiftRequest={spRosteringSetting?.open_shift_claim_request}
          onShiftCountUpdate={setOpenShiftRequestCount}
        />
      )}
      {isShowDeleteModal && (
        <DeleteShiftsModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          calendarView={calendarView?.value}
          handleClose={() => setIsShowDeleteModal(false)}
          isShow={isShowDeleteModal}
          selectedDateTypes={selectedDateTypes}
          handleGetShiftStats={handleGetShiftStats}
          startDate={startDate}
          endDate={endDate}
          selectedOps={selectedOps}
          participantNameLabel={getParticipantLabel(spRosteringSetting?.care_sector, false) + " Name"}
          participantLabelPlural={getParticipantLabel(spRosteringSetting?.care_sector, true)}
          refreshCalendar={refreshCalendar}
        />
      )}

      {/* Full Screen Calendar Modal */}
      {isFullScreenMode && (
        <div className='fixed inset-0 z-[9999] bg-white flex flex-col overflow-hidden'>
          {/* Full Screen Header */}
          <div className='schedule-toolbar schedule-toolbar--elevated calendar-fullscreen-header relative z-20 border-b border-slate-200 bg-white px-3 py-3.5'>
            <div className='schedule-toolbar-row flex w-full min-w-0 flex-wrap items-end gap-1.5 lg:gap-2'>
              <div className='schedule-toolbar-main flex flex-nowrap items-end gap-1.5 lg:gap-2'>
              <div className='schedule-toolbar-filters flex flex-nowrap items-end gap-x-1.5 lg:gap-x-2'>
              <div className='flex w-[140px] shrink-0 flex-col'>
                <label className='mb-1 block text-xs font-medium leading-4 text-gray-600'>
                  View
                </label>
                <SelectOption
                  cssClass='text-xs schedule-toolbar-select normal-case'
                  isSearch={false}
                  useMenuPortal={true}
                  selectedOption={calendarView}
                  handleChange={setCalendarView}
                  data={calendarViewOptions}
                />
              </div>
              {calendarView?.value === "participant-view" && (
                <div className='schedule-service-support flex w-max shrink-0 flex-col'>
                  <label className='mb-1 block text-xs font-medium leading-4 text-gray-600'>
                    Service Support
                  </label>
                  <SelectOption
                    cssClass='z-50 text-xs roster-compact-multiselect normal-case'
                    isMulti
                    useMenuPortal={true}
                    isLoading={serviceTypeLoader || spRosteringSettingLoader}
                    isDisabled={serviceTypeLoader || spRosteringSettingLoader}
                    isClearable={false}
                    isSearch={false}
                    selectedOption={serviceTypeSelectedOptions}
                    handleChange={handleServiceTypeChange}
                    data={serviceTypeOptions}
                  />
                </div>
              )}
              </div>
              <div className='schedule-date-range shrink-0'>
                <NewDateRangeSelect
                  enableDailyView
                  defaultType={spRosteringSetting?.calendar_type}
                  defaultFortnightView={
                    spRosteringSetting?.default_fortnight
                  }
                  dateHandler={handleDateChange}
                />
              </div>
              </div>

              <div className='schedule-toolbar-actions ml-auto flex w-full shrink-0 flex-nowrap items-center justify-end sm:w-auto'>
                <button
                  type='button'
                  data-tooltip-id='add-shift-tooltip-fs'
                  data-tooltip-content='Add Shift'
                  disabled={isUserGracePeriodOver}
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    if (isUserGracePeriodOver) {
                      return;
                    }
                    setSelectedShiftRequest(null);
                    setIsOpenShiftModal(true);
                  }}
                  className={classNames(
                    SCHEDULE_TOOLBAR_ACTION_BTN,
                    isUserGracePeriodOver ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                  )}
                >
                  <BiPlus className={SCHEDULE_TOOLBAR_ICON} />
                </button>
                <button
                  type='button'
                  data-tooltip-id='delete-shifts-tooltip-fs'
                  data-tooltip-content='Delete Shifts'
                  disabled={isUserGracePeriodOver}
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    if (isUserGracePeriodOver) {
                      return;
                    }
                    setIsShowDeleteModal(true);
                  }}
                  className={classNames(
                    SCHEDULE_TOOLBAR_ACTION_BTN,
                    isUserGracePeriodOver ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                  )}
                >
                  <HiOutlineTrash className={SCHEDULE_TOOLBAR_ICON} />
                </button>
                <button
                  type='button'
                  data-tooltip-id='copy-shifts-tooltip-fs'
                  data-tooltip-content='Copy Shifts'
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    setCopyShifts(true);
                  }}
                  className={SCHEDULE_TOOLBAR_ACTION_BTN + " cursor-pointer"}
                >
                  <MdContentCopy className={SCHEDULE_TOOLBAR_ICON} />
                </button>
                <button
                  type='button'
                  data-tooltip-id='publish-shifts-tooltip-fs'
                  data-tooltip-content='Publish Shifts'
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    setIsShowPublish(true);
                  }}
                  className={SCHEDULE_TOOLBAR_ACTION_BTN + " cursor-pointer"}
                >
                  <MdPublish className={SCHEDULE_TOOLBAR_ICON} />
                </button>
                <button
                  type='button'
                  data-tooltip-id='export-roster-tooltip-fs'
                  data-tooltip-content='Export Roster'
                  disabled={isUserGracePeriodOver}
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    if (isUserGracePeriodOver) {
                      return;
                    }
                    setShowCSVModal(true);
                  }}
                  className={classNames(
                    SCHEDULE_TOOLBAR_ACTION_BTN,
                    isUserGracePeriodOver ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                  )}
                >
                  <TiExportOutline className={SCHEDULE_TOOLBAR_ICON} />
                </button>
                <button
                  type='button'
                  data-tooltip-id='shift-requests-tooltip-fs'
                  data-tooltip-content='Shift Requests'
                  disabled={isUserGracePeriodOver}
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    if (isUserGracePeriodOver) {
                      return;
                    }
                    setIsShiftRequestsModalOpen(true);
                  }}
                  className={classNames(
                    "relative flex items-center justify-center h-7 w-7 shrink-0 rounded-md background-gradient border-gradient text-white shadow-sm hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1",
                    isUserGracePeriodOver
                      ? "cursor-not-allowed opacity-50"
                      : "cursor-pointer"
                  )}
                >
                  <HiOutlineClipboardList className='h-3.5 w-3.5' />
                  {shiftRequestsPendingCount > 0 && (
                    <span className='absolute -top-0.5 -right-0.5 flex min-h-[12px] min-w-[12px] items-center justify-center rounded-full bg-red-600 px-0.5 text-[7px] font-medium text-white'>
                      {shiftRequestsPendingCount > 99
                        ? "99+"
                        : shiftRequestsPendingCount}
                    </span>
                  )}
                </button>
                {spRosteringSetting?.open_shift_claim_request && (
                  <button
                    type='button'
                    data-tooltip-id='open-shifts-tooltip-fs'
                    data-tooltip-content={`Open Shifts${openShiftRequestCount > 0 ? ` (${openShiftRequestCount > 99 ? '99+' : openShiftRequestCount})` : ''}`}
                    disabled={isUserGracePeriodOver}
                    onClick={(e) => {
                      e?.stopPropagation?.();
                      if (isUserGracePeriodOver) {
                        return;
                      }
                      setIsOpenShiftApprovalModal(true);
                    }}
                    className={classNames(
                      "relative " + SCHEDULE_TOOLBAR_ACTION_BTN,
                      isUserGracePeriodOver ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
                    )}
                  >
                    <BiGroup className={SCHEDULE_TOOLBAR_ICON} />
                    {openShiftRequestCount > 0 && (
                      <span className='absolute -top-0.5 -right-0.5 flex min-h-[12px] min-w-[12px] items-center justify-center rounded-full bg-red-600 px-0.5 text-[7px] font-medium text-white'>
                        {openShiftRequestCount > 99 ? "99+" : openShiftRequestCount}
                      </span>
                    )}
                  </button>
                )}
                <button
                  type='button'
                  data-tooltip-id='exit-fullscreen-tooltip'
                  data-tooltip-content='Exit Full Screen'
                  onClick={() => setIsFullScreenMode(false)}
                  className={SCHEDULE_TOOLBAR_ACTION_BTN + " cursor-pointer"}
                >
                  <MdFullscreenExit className={SCHEDULE_TOOLBAR_ICON} />
                </button>
                <button
                  type='button'
                  data-tooltip-id='refresh-tooltip-fs'
                  data-tooltip-content='Refresh'
                  onClick={(e) => {
                    e?.stopPropagation?.();
                    if (!workerAndPartsListLoader) {
                      refreshCalendar({ isRefreshCall: true });
                    }
                  }}
                  disabled={workerAndPartsListLoader}
                  className={SCHEDULE_TOOLBAR_REFRESH_BTN}
                >
                  {workerAndPartsListLoader ? (
                    <Loader
                      isSmallView={true}
                      cssClass={"text-black mr-0 p-0 flex"}
                    />
                  ) : (
                    <img
                      className={SCHEDULE_TOOLBAR_ICON}
                      src={refreshIcon}
                      alt='refresh icon'
                    />
                  )}
                </button>

                {/* Tooltips */}
                <Tooltip id='add-shift-tooltip-fs' place='top' />
                <Tooltip id='delete-shifts-tooltip-fs' place='top' />
                <Tooltip id='copy-shifts-tooltip-fs' place='top' />
                <Tooltip id='publish-shifts-tooltip-fs' place='top' />
                <Tooltip id='export-roster-tooltip-fs' place='top' />
                <Tooltip id='shift-requests-tooltip-fs' place='top' />
                <Tooltip id='open-shifts-tooltip-fs' place='top' />
                <Tooltip id='exit-fullscreen-tooltip' place='top' />
                <Tooltip id='refresh-tooltip-fs' place='top' />
              </div>
            </div>
          </div>

          {/* Full Screen Calendar Content */}
          <div className='flex-1 overflow-hidden bg-slate-50 min-h-0'>
            <div className='h-full overflow-x-auto overflow-y-auto p-4 calendar-fullscreen'>
              {(workerAndPartsListLoader &&
                isPaginationLoading === LOADER_STATUS.NA) ||
              isServiceCategoriesFetchCall ? (
                <ScheduleCalendarSkeleton rows={10} cols={8} />
              ) : (
                calendarView?.value && (
                  <Suspense fallback={<ScheduleCalendarSkeleton rows={10} cols={8} />}>
                    <Calendar
                      reachedLast={reachedLast}
                      isPaginationLoading={isPaginationLoading}
                      paginationObj={paginationObj}
                      isUserGracePeriodOver={isUserGracePeriodOver}
                      workerAndPartsListLoader={workerAndPartsListLoader}
                      isSort={isSortCalendarShiftsItem}
                      calendarView={calendarView.value}
                      workers={workerOptions}
                      participants={participantOptions}
                      dropdownWorkers={dropdownWorkerOptions}
                      dropdownParticipants={dropdownParticipantOptions}
                      isUserSearchLoading={isDropdownCatalogLoading}
                      sortCalendarShiftsItem={(e) => {
                        setIsSortCalendarShiftsItem(e);
                        refreshCalendar({ sort: e, isRefreshCall: true });
                      }}
                      clearClipboard={clearClipboard}
                      setCopiedText={setCopiedText}
                      copiedText={copiedText}
                      handlePasteShift={handlePasteShift}
                      copyWorkerShiftLoader={copyWorkerShiftLoader}
                      refreshCalendar={refreshCalendar}
                      setReachedLast={setReachedLast}
                      scrollablePagination={scrollablePagination}
                      serviceCategoriesTypes={serviceCategoriesTypes}
                      selectedOps={selectedOps}
                      setSelectedops={setSelectedops}
                      handleGetShiftStats={handleGetShiftStats}
                      startDate={startDate}
                      endDate={endDate}
                      spRosteringSetting={spRosteringSetting}
                      serviceTypeSelectedOptions={serviceTypeSelectedOptions}
                    />
                  </Suspense>
                )
              )}
            </div>
          </div>

          {/* Full Screen Footer */}
          <div className='border-t bg-white py-4 px-6'>
            <div className='flex justify-center items-center gap-3'>
              <div className='flex items-center gap-x-2'>
                <span className='p-2 rounded-full bg-orange-100 border border-orange-500 inline-block'></span>
                <p className='text-xs font-semibold'>
                  {shiftStats?.unpublished_shifts || 0} Unpublished Shifts
                </p>
              </div>
              <div className='flex items-center gap-x-2'>
                <span className='p-2 rounded-full bg-green-100 border border-green-500 inline-block'></span>
                <p className='text-xs font-semibold'>
                  {shiftStats?.published_shifts || 0} Published Shifts
                </p>
              </div>
              <div className='flex items-center gap-x-2'>
                <span className='p-2 rounded-full border-[#ff5349] border bg-[#ffcbc8] inline-block'></span>
                <p className='text-xs font-semibold'>
                  {shiftStats?.rejected_shifts || 0} Rejected Shifts
                </p>
              </div>
              <div className='flex items-center gap-x-2'>
                <span className='p-2 rounded-full bg-yellow-100 border border-yellow-500 inline-block'></span>
                <p className='text-xs font-semibold'>
                  {shiftStats?.open_shifts || 0} Open Shifts
                </p>
              </div>
              <div className='flex items-center gap-x-2'>
                <span className='p-2 rounded-full bg-amber-100 border border-amber-500 inline-block'></span>
                <p className='text-xs font-semibold'>
                  {shiftStats?.v5_partial_open_slots || 0} Partial Open
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Schedule;
